import loadjs from 'loadjs';

loadjs('/static/tinymce/tinymce.min.js', 'tinymce');

export default (key, options = {}) => new Promise((resolve, reject) => {
    loadjs.ready(key, {
        success: resolve,
        error: reject,
        ...options,
    });
});
